/**
 * Lane E client wire: send chat to the lobby room and surface a subscription
 * hook for ChatPanel. The real ArraySchema subscription is set up inside
 * net/colyseus.ts when the lobby room is joined; that callback appends to
 * the zustand `chatLog`. This hook re-exports a no-op so ChatPanel can call
 * it unconditionally without each render triggering re-subscription.
 */
import type { ChatSendMsg } from "@solblox/shared";

import { useStore } from "../store";

/** Send a chat line to whichever lobby room is currently connected. */
export function sendChat(body: string): void {
  const trimmed = body.trim();
  if (trimmed.length === 0) return;
  const room = useStore.getState().currentRoom;
  if (!room) return;
  const msg: ChatSendMsg = { body: trimmed.slice(0, 280) };
  room.send("chat", msg);
}

/**
 * Subscription hook consumed by ChatPanel. The actual schema subscription is
 * established at room-join time in net/colyseus.ts, so this hook only exists
 * to satisfy the ChatPanel contract and provide a stable API for future
 * per-component subscription logic if it becomes useful.
 */
export function useChatSubscription(): void {
  // schema subscription is owned by net/colyseus.ts#wireLobbyRoom
}
